import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {},
  banner: {
    width: "100%",
    marginBottom: theme.spacing.space24,
    height: 278,
  },
  playWin: {},
  guide: {
    borderBottom: `1px solid ${theme.colors.border1}`,
    paddingBottom: theme.spacing.space24,
    marginBottom: theme.spacing.space24,
  },
  rankCard: {
    marginBottom: theme.spacing.space16,
  },
  rankLoading: {
    marginBottom: theme.spacing.space16,
    height: 60,
  },
}));
